import createIcon from '../../createIcon';

/**
 * @component @name SafetyDivider
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTEgNUgxM1YxOUgxMVY1Wk01IDEyQzYuMSAxMiA3IDExLjEgNyAxMEM3IDguOSA2LjEgOCA1IDhDMy45IDggMyA4LjkgMyAxMEMzIDExLjEgMy45IDEyIDUgMTJaTTcuNzggMTMuNThDNi45MyAxMy4yMSA1Ljk5IDEzIDUgMTNDNC4wMSAxMyAzLjA3IDEzLjIxIDIuMjIgMTMuNThDMS40OCAxMy45IDEgMTQuNjIgMSAxNS40M1YxNkg5VjE1LjQzQzkgMTQuNjIgOC41MiAxMy45IDcuNzggMTMuNThaTTE5IDEyQzIwLjEgMTIgMjEgMTEuMSAyMSAxMEMyMSA4LjkgMjAuMSA4IDE5IDhDMTcuOSA4IDE3IDguOSAxNyAxMEMxNyAxMS4xIDE3LjkgMTIgMTkgMTJaTTIxLjc4IDEzLjU4QzIwLjkzIDEzLjIxIDE5Ljk5IDEzIDE5IDEzQzE4LjAxIDEzIDE3LjA3IDEzLjIxIDE2LjIyIDEzLjU4QzE1LjQ4IDEzLjkgMTUgMTQuNjIgMTUgMTUuNDNWMTZIMjNWMTUuNDNDMjMgMTQuNjIgMjIuNTIgMTMuOSAyMS43OCAxMy41OFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SafetyDivider = createIcon('SafetyDivider', [
  [
    'path',
    {
      d: 'M11 5H13V19H11V5ZM5 12C6.1 12 7 11.1 7 10C7 8.9 6.1 8 5 8C3.9 8 3 8.9 3 10C3 11.1 3.9 12 5 12ZM7.78 13.58C6.93 13.21 5.99 13 5 13C4.01 13 3.07 13.21 2.22 13.58C1.48 13.9 1 14.62 1 15.43V16H9V15.43C9 14.62 8.52 13.9 7.78 13.58ZM19 12C20.1 12 21 11.1 21 10C21 8.9 20.1 8 19 8C17.9 8 17 8.9 17 10C17 11.1 17.9 12 19 12ZM21.78 13.58C20.93 13.21 19.99 13 19 13C18.01 13 17.07 13.21 16.22 13.58C15.48 13.9 15 14.62 15 15.43V16H23V15.43C23 14.62 22.52 13.9 21.78 13.58Z',
      key: '16eq7y',
    },
  ],
]);

export default SafetyDivider;
